import React from 'react';
import './css/contact.css';
import { Helmet } from 'react-helmet-async';
import ContactForm from "./sub-components/ContactForm";

// Keep these in sync with the "/Contact" entry in SeoPageRenderer.cs
const PAGE_URL = "https://www.dysband.com/Contact";
const PAGE_TITLE = "Book a Yacht Rock Band in Phoenix | Dirty Yachtin' Scoundrels";
const PAGE_DESCRIPTION =
    "Contact the yacht rock band Dirty Yachtin' Scoundrels for bookings, private parties, corporate events, or general inquiries.";
const PAGE_IMAGE =
    "https://www.dysband.com/media/yacht_rock_band_dirty_yachtin_scoundrels_live.webp";

const Contact = () => {
    return (
        <div className="booking">
            <Helmet>
                <title>{PAGE_TITLE}</title>
                <meta name="description" content={PAGE_DESCRIPTION} />
                <link rel="canonical" href={PAGE_URL} />

                <meta property="og:title" content={PAGE_TITLE} />
                <meta property="og:description" content={PAGE_DESCRIPTION} />
                <meta property="og:url" content={PAGE_URL} />
                <meta property="og:image" content={PAGE_IMAGE} />
                <meta property="og:image:alt" content="Dirty Yachtin' Scoundrels performing on stage with dramatic lighting." />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Dirty Yachtin' Scoundrels" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={PAGE_TITLE} />
                <meta name="twitter:description" content={PAGE_DESCRIPTION} />
                <meta name="twitter:image" content={PAGE_IMAGE} />
            </Helmet>

            {/* Was an <h2>; the page had no <h1>. If the size looks different, adjust .booking h1 in contact.css */}
            <h1>Contact Dirty Yachtin' Scoundrels</h1>
            <p>Get in touch with the smooth sounds of Dirty Yachtin' Scoundrels! Book us for your next event, ask a question, or just say hello. Easy, breezy, and always professional.</p>
            <p>Based in Phoenix, Arizona, we play weddings, corporate events, private parties, festivals, and public shows in the Phoenix area, across Arizona, and nationwide. Tell us your date, location, and event type and we will get back to you.</p>
            <ContactForm />

        </div>
    );
};

export default Contact;